import { LoadingOverlay as MantineLoadingOverlay, LoadingOverlayProps } from '@mantine/core';
import { Loader } from '../loader/Loader';

export const LoadingOverlay = (props: LoadingOverlayProps) => (
    <MantineLoadingOverlay loaderProps={{ children: <Loader /> }} {...props} />
);
